import { apiGet } from '../client';
import { BusinessCustomerPageSchema, type BusinessCustomerPage } from '../schemas';

export function listCustomers(cursor?: string, limit = 20): Promise<BusinessCustomerPage> {
  const params = new URLSearchParams({ limit: String(limit) });
  if (cursor) params.set('cursor', cursor);
  return apiGet(`/v1/business/customers?${params.toString()}`, BusinessCustomerPageSchema);
}
